import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
@Injectable()
export class CommonService {

  private subject = new Subject<any>();
  data = this.subject.asObservable();

  constructor() { }

  moveToNext(data){
    this.subject.next(data);
  }


  private subjects = [];

  publish(eventName: string) {
  // ensure a subject for the event name exists
  this.subjects[eventName] = this.subjects[eventName] || new Subject();
  
  // publish event
  this.subjects[eventName].next();
  }
  
  on(eventName: string) {
  // ensure a subject for the event name exists
  this.subjects[eventName] = this.subjects[eventName] || new Subject();
  
  // return observable
  return this.subjects[eventName].asObservable();
  }


}
